import { eventToContentPart, parseStreamLine } from './parsing';

import type { ContentPart } from '../types/chat.types';

export function isAbortLikeError(error: Error): boolean {
  return (
    error.name === 'AbortError' ||
    /aborted|AbortError|BodyStreamBuffer was aborted/i.test(error.message)
  );
}

export async function readStream(
  reader: ReadableStreamDefaultReader<Uint8Array>,
  onPart: (part: ContentPart) => void
): Promise<{ sawComplete: boolean }> {
  const decoder = new TextDecoder();
  let buffer = '';
  let sawComplete = false;

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop() || '';
    for (const line of lines) {
      const evt = parseStreamLine(line);
      if (!evt) continue;
      const part = eventToContentPart(evt);
      if (part) onPart(part);
      if (evt.type === 'complete') sawComplete = true;
    }
  }

  return { sawComplete };
}
